import { s } from "@kosmod/pancake";
import { AssetID, AssetReference } from "@kosmod/assets";
import { MiniModel, MiniModelID, MiniSpriteID } from "../miniRender";
import { define } from "./define";
import { K3D } from "@kosmod/graphics-3d";

export const renderLogic = define('render', s.ref<MiniRenderLogic>()(s.du('renderType', {
  'quick-sprite': {
    spriteId: s.optional(MiniSpriteID),
  },
  'game-mat': {
    spriteId: s.optional(MiniSpriteID),
    size: K3D.Vector2,
  },
  'model': {
    modelId: s.optional(MiniModelID),
  }
})))

export type MiniRenderLogic =
  | {
      renderType: 'quick-sprite',
      spriteId: null | MiniSpriteID,
    }
  | {
      renderType: 'model',
      modelId: null | MiniModelID,
    }
  | {
      renderType: 'game-mat',
      spriteId: null | MiniSpriteID,
      size: K3D.Vector2,
    }

export const alignmentLogic = define('alignment', s.o({
  rotation: s.lu(['free', 'axial', 'none']),
  position: s.lu(['free', 'grid', 'edge', 'vertex'])
}));

// export const  = define('alignment', s.o({
//   rotation: s.lu(['free', 'axial', 'none']),
//   position: s.lu(['free', 'grid', 'edge', 'vertex'])
// }));
